import React from "react"
import "twin.macro"
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll"

//  why not map fucntion ? for this? DRsir their were lot other mistakes i was first correctingg them u told
const LastSection = () => {
  return (
    <div tw="border-gray-500 mx-auto p-5">
      <div tw="md:grid grid-cols-2 gap-16">
        <div>
          <div tw="md:text-3xl font-extrabold mt-12 mx-auto  ">
            PERGO.
            <div tw="mx-auto  md:text-xl font-light mt-6">
              Aliquam orci nullam tempor sapien orci gravida donec enim ipsum
              porta justo integer at velna vitae auctor integer congue magna
            </div>
            <div tw="flex mt-12">
              <svg
                width="10%"
                height="10%"
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                />
              </svg>
              <svg
                width="10%"
                height="10%"
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                width="10%"
                height="10%"
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                width="10%"
                height="10%"
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div tw="grid md:(grid-cols-3 gap-32) mx-auto">
          <div>
            <div tw="text-2xl font-bold">Products</div>
            <div tw="mt-6">
              How It Works?
              <div>
                Community<div>Carrers</div>
              </div>
            </div>
          </div>
          <div>
            <div tw="text-2xl font-bold">Company</div>
            <div tw="mt-6">
              About Us
              <div>
                Core Services<div>FAQ'S</div>
              </div>
            </div>
          </div>
          <div>
            <div tw="text-2xl  font-bold">Resources</div>
            <div tw="mt-6">
              Life Chatting
              <div>
                Privacy
                <div>
                  Returns<div>Policy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div tw="flex justify-start mt-14">
        <Link
          activeClass="active"
          className="test1"
          to={"HEROSECTION"}
          spy={true}
          smooth={true}
          duration={500}
        >
          {" "}
          <div tw="align-items[flex-end]">
            <svg
              width="50px"
              height="50px"
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
              />
            </svg>
          </div>
        </Link>
      </div>
      <div tw="text-align[center] text-3xl font-style[italic] font-bold">
        @ Created By Tech Tomatoes @
      </div>
    </div>
  )
}

export default LastSection
